import {useEffect} from 'react';

/**
 * This hook will set the value to first value of the array if nothing is selected and there is only 1 valu ein array
 * @param array
 * @param value
 * @param setValue
 * @param enabled
 * @param setWhenArrayIsLargerThanOne when enabled, set the first value only when array is larger than 1
 * @returns
 */
export default function useArraySetFirstValue<T>(
  array: T[],
  value: T | undefined,
  setValue: (value: T) => void,
  enabled?: boolean,
  setWhenArrayIsLargerThanOne?: boolean,
): void {
  useEffect(() => {
    if ((array.length === 1 || (setWhenArrayIsLargerThanOne && array.length > 1)) && !value && enabled) {
      setValue(array[0]);
    }
  }, [array, value, setValue, enabled, setWhenArrayIsLargerThanOne]);
}
